//================================================= Api Endpoints Starts ============================================================//
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const API = {
  auth: {
    login: "/user/login",
    signUp: "/",
    forgetpassword: "/users/forgetpassword",
  },
  art: {
    all: "/art/all",
    create: "/",
    update: "/art/",
  },
  user: {
    all: "/user/",
    create: "/",
    update: "/user/update",
  },
};
//================================================= Api Endpoints Ends Here ============================================================//

//================================================= Api Request Method Starts ============================================================//
export const apiRequest = async (method, url, data = null) => {
  const walletAddress = localStorage.getItem("walletAddress");

  const headers = {
    "Content-Type": "application/json",
  };

  // Add Authorization header if accessToken exists
  if (walletAddress) {
    headers["Authorization"] = `Bearer ${walletAddress}`;
  }

  const options = {
    method,
    headers,
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(domainpath + url, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};

// Generic functions for each HTTP method
const getData = async (url) => {
  return apiRequest("GET", url);
};

const postData = async (url, data) => {
  return apiRequest("POST", url, data);
};

const putData = async (url, data) => {
  return apiRequest("PUT", url, data);
};

const deleteData = async (url) => {
  return apiRequest("DELETE", url);
};

export { API, getData, postData, putData, deleteData };
//================================================= Api Request Method Ends ============================================================//
